import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './scroll-arrows.scss';

const ARROW_CONTAINER_CLASS_NAME = 'arrow pos-a top-0 bottom-0 align-items-center';
const ARROW_CLASS_NAME = 'h-100 p-1 size-24 text-blue-40 bg-transparent rounded border-0';

export function ScrollArrows({ heightRef = null, onArrowClick, arrows: { left, right } }) {
  const [hasHeight, setHasHeight] = useState(false);
  const arrowsRef = useRef();

  useEffect(() => {
    const refHeight = heightRef?.current?.clientHeight;
    if (refHeight) {
      arrowsRef.current.style.height = `${refHeight}px`;
      setHasHeight(true);
    }
  }, [heightRef]);

  function onLeftArrowClick() {
    onArrowClick(false);
  }

  function onRightArrowClick() {
    onArrowClick(true);
  }

  return (
    <div ref={arrowsRef} className={classnames('scroll-arrows pos-a top-0 left-0 w-100', { 'd-none': !hasHeight })}>
      <div
        className={classnames(ARROW_CONTAINER_CLASS_NAME, 'left left-0', {
          'd-flex': left,
          'd-none': !left,
        })}
      >
        <button
          className={classnames('icon-arrow-left3 ps-0_25', ARROW_CLASS_NAME)}
          onClick={onLeftArrowClick}
          aria-label="More Trims"
        />
      </div>
      <div
        className={classnames(ARROW_CONTAINER_CLASS_NAME, 'right right-0 justify-content-end', {
          'd-flex': right,
          'd-none': !right,
        })}
      >
        <button
          className={classnames('icon-arrow-right3 pe-0_25', ARROW_CLASS_NAME)}
          onClick={onRightArrowClick}
          aria-label="More Trims"
        />
      </div>
    </div>
  );
}

ScrollArrows.propTypes = {
  onArrowClick: PropTypes.func.isRequired,
  arrows: PropTypes.shape({ left: PropTypes.bool, right: PropTypes.bool }).isRequired,
  heightRef: PropTypes.shape({}),
};
